import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {IUserListNormalizedClient, IUserProfile, IUserProfileBase} from "../define";

export const GetUserListByIdUrl = `/get_user_list`;
export const GetUserListByIdMethod = ERequestType.TYPE_GET;

export interface GetUserListByIdRequest extends ApiRequest {
	idList: string[];
	profileQuery: (keyof IUserProfile)[]|'*';
}

export interface GetUserListByIdResponse<IProfile extends IUserProfileBase> extends ApiResponse {
	userList: IUserListNormalizedClient<IProfile>[];
}
